import { useEffect } from 'react';
import { useFacebookPixel } from '../context/FacebookPixelContext';
import { useDataReducer } from './useDataReducer';

export const useFacebookPixelManager = () => {
  const { setPixelId, pixelId, isPixelLoaded, trackEvent } = useFacebookPixel();
  const { data, isLoading } = useDataReducer();

  // Update pixel ID when data changes
  useEffect(() => {
    if (!isLoading && data) {
      const newPixelId = data.facebookPixelId?.trim();
      if (newPixelId && newPixelId !== pixelId) {
        setPixelId(newPixelId);
      } else if (!newPixelId && pixelId) {
        // Remove pixel if no ID is set
        setPixelId(null);
      }
    }
  }, [data, isLoading, pixelId, setPixelId]);

  return {
    pixelId,
    isPixelLoaded,
    trackEvent,
  };
};